import { render, staticRenderFns } from "./FormResponseType4.vue?vue&type=template&id=17f283c6&scoped=true&"
import script from "./FormResponseType4.vue?vue&type=script&lang=js&"
export * from "./FormResponseType4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f283c6",
  null
  
)

export default component.exports